<template>
	<div class="bg-red-500 h-auto min-h-screen w-full">
		<div class="flex">
			<a class="w-1/2 cursor-pointer" @click="$router.replace('register')">
				<div class="bg-red-200 text-red-900 text-center text-3xl py-3 sm:py-6" style="border-radius: 0 0 20px 0;">
					REGISTER
				</div>
			</a>
			<div class="w-1/2 bg-red-500 text-red-70 text-center text-3xl py-3 sm:py-6 cursor-pointer">
				LOGIN
			</div>
		</div>
		
		<form>
			<div class="px-5 md:px-10 lg:px-32 xl:px-64 pt-6 pb-32">
				<p class="text-white text-3xl font-body leading-tight">Welcome back!</p>
				
				<error v-if="emailVerified" class="w-screen bg-green-200 mt-2 mb-4 px-5 md:px-10 lg:px-32 xl:px-64 -mx-5 md:-mx-10 lg:-mx-32 xl:-mx-64" colour="green" icon="check_circle" title="Email verified" body="Your email address has been successfully verified" />
				<error v-if="emailVerificationFailed" class="w-screen mt-2 mb-4 px-5 md:px-10 lg:px-32 xl:px-64 -mx-5 md:-mx-10 lg:-mx-32 xl:-mx-64" colour="red" icon="triangle_error" title="Invalid link" body="Your email address could not be verified" />
				
				<div v-if="error" class="mt-5 mb-1 py-4 -mx-5 md:-mx-10 lg:-mx-32 xl:-mx-64 px-5 md:px-10 lg:px-32 xl:px-64 bg-red-800 text-white text-xl font-body">
					{{ error }}
				</div>
				
				<div>
					<label class="block font-body text-white pt-4 pb-1" style="font-size: 1.375rem;">Email:</label>
					<input @keypress.enter="submitForm" class="block w-full font-body rounded-none bg-transparent text-white placeholder-red-70 border-8 border-solid border-red-200 px-2 py-2 text-2xl" type="email" placeholder="Enter your email address..." v-model="email" />
				</div>
				
				<div>
					<label class="block font-body text-white pt-4 pb-1" style="font-size: 1.375rem;">Password:</label>
					<input @keypress.enter="submitForm" class="block w-full font-body rounded-none bg-transparent text-white placeholder-red-70 border-8 border-solid border-red-200 px-2 py-2 text-2xl" type="password" placeholder="Enter your password..." v-model="password" />
				</div>
				
				<p class="text-white text-xl font-body leading-tight pt-4">If you have forgotten your password, please <span class="text-green-300 hover:text-white focus:text-white cursor-pointer" tabindex="0" @click="showPasswordRecovery = true" @keypress.enter="showPasswordRecovery = true">click here</span>.</p>
			</div>
			
			<a @click="submitForm" @keypress.enter="submitForm" tabindex="0" class="fixed bottom-0 left-0 w-full border-none bg-green-500 text-grey-900 text-3xl text-center leading-tight py-4 sm:py-8 no-underline cursor-pointer">
				BEGIN
			</a>
		</form>
		
		<recoverymodal v-if="showPasswordRecovery" />
	</div>
</template>

<style>

</style>

<script>
import Storages from 'js-storage';
import axios from 'axios';
import ErrorBox from '../components/ErrorBox.vue';
import RecoveryModal from '../components/RecoveryModal.vue';

export default {
	name: 'Login',
	path: '/login',
	components: {
		'error': ErrorBox,
		'recoverymodal': RecoveryModal
	},
	data() {
		return {
			email: "",
			password: "",
			error: null,
			storage: null,
			emailVerified: false,
			emailVerificationFailed: false,
			showPasswordRecovery: false
		}
	},
	created() {
		this.storage = Storages.localStorage;

		if (this.storage.isSet('session_key')) {
			this.$router.push("/home");
			return;
		}

		var fragment = window.location.hash.substr(1);

		if (fragment == "emailVerified") {
			this.emailVerified = true;
		}

		if (fragment == "emailVerificationFailed") {
			this.emailVerificationFailed = true;
		}
	},
	methods: {
		submitForm() {
			var that = this;
			this.error = false;
			axios.get('https://bakerstreet.arturs.co.uk/api/lostinthecity/login/submit?email=' + this.email + '&password=' + this.password)
			.then(function (response) {
				var data = response.data;

				if (data.success == true) {
					that.storage.set('session_key', data.response.session_key);
					that.storage.set('authed_user', data.response.user);
					that.storage.set('welcome_alert', data.response.welcome_alert);
					that.storage.set('online_config', data.response.online_config);
					that.storage.set('disable_challenges_alert', data.response.disable_challenges_alert);
					that.$router.push('home');
				} else {
					that.error = data.response;
				}
			})
			.catch(function (error) {
				if (error.response) {
					var data = error.response.data;
					that.error = data.response;
				} else {
					that.error = "An error has occured: " + error;
				}
			});
		}
	}
}
</script>